import { render, staticRenderFns } from "./AppTaskAudio.vue?vue&type=template&id=3b459aa2"
import script from "./AppTaskAudio.vue?vue&type=script&lang=js"
export * from "./AppTaskAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports